const distance = (t1, t2) => {
  const dx = t2.clientX - t1.clientX;
  const dy = t2.clientY - t1.clientY;

  return Math.sqrt(dx * dx + dy * dy);
};

export default distance;
